import React, {useState, useEffect} from 'react';
import YouTube from 'react-youtube';

import './modal-video.scss'

const ModalVideo = props => {
    const [heightVideo, setHeight] = useState(390);
    const [widthVideo, setWidth] = useState(720);

    useEffect(() => {
        
        setHeight(window.innerHeight - 50);
        setWidth(window.innerWidth - 50);

    });

    const opts = {
        // height: '390',
        // width: '720',
        height: heightVideo,
        width: widthVideo,
        playerVars: { // https://developers.google.com/youtube/player_parameters
          autoplay: 1
        },
      };
    if(props.activeModal === props.identify){
        return (
            <div className="f-video-opacity">
                <div className="f-video-modal">
                    <span onClick={() => props.setModalActive(null)} className="f-close-modal icon2-close"></span>
                    <YouTube
                        videoId={props.url.split('/')[props.url.split('/').length -1]}
                        opts={opts}
                    />
                </div>
            </div>
        )

    }else{
        return null;
    }
}

export default ModalVideo
